import { Image as AImage, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { getMediaFile } from "../services/media.service";

export function PImage({
  mediaId,
  style,
  wrapperStyle,
}: {
  mediaId?: string;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
}) {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [avatarUrl, setAvatarUrl] = useState<string>("/assets/placeholder.png");
  const [isError, setError] = useState<boolean>(false);

  useEffect(() => {
    if (mediaId) {
      if (!mediaId.startsWith("http")) {
        // Our file service is private, so we need to "download" it and render
        getMediaFile({
          mediaId,
          onSuccess: (data) => {
            setAvatarUrl(URL.createObjectURL(data));
            setLoading(false);
          },
          onError: () => {
            setError(true);
            setLoading(false);
          },
        });
      } else {

        const img = new Image();
        img.src = mediaId;
        img.onload = () => {
          setAvatarUrl(mediaId);
          setLoading(false);
        };
        img.onerror = () => {
          setError(true);
          setLoading(false);
        };

      }
    } else {
      setAvatarUrl("/assets/placeholder.png");
      setLoading(false);
    }
  }, [mediaId]);

  if (isLoading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Skeleton.Image
          active
          className="skeleton-image"
          style={{ ...style, minHeight: "96px" }}
        />
      </div>
    );
  }

  if (isError) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Skeleton.Image
          className="skeleton-image"
          style={{ ...style, minHeight: "96px" }}
        />
      </div>
    );
  }

  return (
    <AImage
      preview={false}
      src={avatarUrl || mediaId}
      style={{ ...style }}
      wrapperStyle={
        wrapperStyle || {
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }
      }
    />
  );
}
